import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { type AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails, {
  type AccordionDetailsProps,
} from '@mui/material/AccordionDetails';
import MuiAccordionSummary, {
  type AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

export const DiagramAccordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

export const DiagramAccordionSummary = styled(
  (props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={
        <ArrowForwardIosSharpIcon
          sx={{ fontSize: '0.9rem', color: 'var(--emrald-text)' }}
        />
      }
      {...props}
    />
  ),
)(() => ({
  height: 25,
  minHeight: 25,
  fontSize: 10,
  padding: '0 10px',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: 0,
  },
}));

export const DiagramAccordionDetails = styled(
  (props: AccordionDetailsProps) => (
    <MuiAccordionDetails
      onClick={e => {
        e.stopPropagation();
      }} // Stop the click event propagation
      {...props}
    />
  ),
)({
  paddingLeft: 0,
  borderTop: '1px solid var(--emrald-divider)',
});
